import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { FlowTimelineFile } from './FlowTimelineFile';

const FlowTimelineFileBridge = react2angular(FlowTimelineFile, ['filemeta']);

export default FlowTimelineFileBridge;
